import {
    GET_ALL_SCHEDULED,
    UPDATE_SCHEDULED_ORDERS,
    ACTION_SCHEDULED_FASTFORWARD,
    ACTION_SCHEDULED_CONFIRMATION,
    ACTION_SCHEDULED_CLEAN,
} from '../constants';

const INITIAL_STATE = {
    scheduleds: [],
    scheduled: {
        selected: null,
        highlighted: [],
        action: {
            confirmation: [],
            pending: [],
        },
        status: {
            dispatched: []
        }
    }
};

const scheduledReducer = (state=INITIAL_STATE, action) => {
    switch(action.type){
        case GET_ALL_SCHEDULED: 
        return {
            ...state,
            scheduleds: action.scheduleds
        }
        case UPDATE_SCHEDULED_ORDERS:
        let addScheduledOrder = []
        const dispatched = 'dispatched'
        if (Array.isArray(action.updatedOrders)) {
            addScheduledOrder = action.updatedOrders.reduce((acc, order) => {
                if (order.dispatchStatus !== dispatched) {
                  return acc;
                }
                return [...acc, order.id];
              }, []);
        }
        return {
            ...state,
            scheduled: {
                selected: null,
                highlighted: [],
                action: {
                    confirmation: [],
                    pending: action.scheduled,
                },
                status: {
                    dispatched: addScheduledOrder
                }
            }
        }
        case ACTION_SCHEDULED_FASTFORWARD:
        return {
            ...state,
            scheduled: {
                selected: null,
                highlighted: action.scheduled.id,
                action: {
                    confirmation: action.scheduled,
                    pending: [],
                },
                status: {
                    dispatched: []
                }
            }
        }
        case ACTION_SCHEDULED_CLEAN:
        return {
            ...state,
            scheduled: {
                selected: null,
                highlighted: {},
                action: {
                    confirmation: [],
                    pending: [],
                },
                status: {
                    dispatched: []
                }
            }
        }
        case ACTION_SCHEDULED_CONFIRMATION:
        return {
            ...state,
            scheduled: {
                selected: null,
                highlighted: [],
                action: {
                    confirmation: [],
                    pending: action.scheduled,
                },
                status: {
                    dispatched: []
                }
            }
        }
        default:
        return state
    }
}

export default scheduledReducer;